import "../scss/main.scss";

/* =====================================
   CONFIG / HELPERS
===================================== */

const body = document.body;
//body.style.background = "red";
const navBp = getComputedStyle(document.documentElement)
  .getPropertyValue("--breakpoint-nav-min")
  .trim();

const screenSize = window.matchMedia(`(min-width: ${navBp})`);

const menuToggle = document.querySelector(".menu-toggle");
const header = document.querySelector(".site-header");

const hasMenu = header && menuToggle;

const labelOpen = menuToggle?.dataset.labelOpen;
const labelClose = menuToggle?.dataset.labelClose;

/* =====================================
   MENU TOGGLE
===================================== */
function openMenu() {
  header.classList.add("is-open");
  menuToggle.setAttribute("aria-expanded", "true");
  menuToggle.setAttribute("aria-label", labelClose);
}

function closeMenu() {
  header.classList.remove("is-open");
  menuToggle.setAttribute("aria-expanded", "false");
  menuToggle.setAttribute("aria-label", labelOpen);
}

if (hasMenu) {
  menuToggle.addEventListener("click", () => {
    const isOpen = header.classList.contains("is-open");
    isOpen ? closeMenu() : openMenu();
  });

  // Schließen per ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && header.classList.contains("is-open")) {
      closeMenu();
      menuToggle.focus();
    }
  });

  // Klick außerhalb
  document.addEventListener("click", (e) => {
    if (!header.contains(e.target) && !menuToggle.contains(e.target)) {
      closeMenu();
    }
  });
}

// Resize
screenSize.addEventListener("change", (e) => {
  if (e.matches && hasMenu) {
    closeMenu();
  }
});

// Scroll
let lastScrollState = false;

const backToTopBtn = document.querySelector("#back-top");
let lastBackToTopState = false;

window.addEventListener("scroll", () => {
  const scrollY = window.scrollY;

  // Anzeige schmales Menü
  const isScrolled = scrollY > 170;

  if (isScrolled !== lastScrollState) {
    body.classList.toggle("is-scrolled", isScrolled);
    lastScrollState = isScrolled;
  }

  // back-to-top
  const showBackToTop = scrollY > 800;

  if (backToTopBtn && showBackToTop !== lastBackToTopState) {
    backToTopBtn.classList.toggle("is-visible", showBackToTop);
    lastBackToTopState = showBackToTop;
  }
});
